import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { creditAPI } from "../services/api";
import { useTranslation } from "react-i18next";

const PaymentCancel = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get("session_id");

    if (sessionId) {
      creditAPI
        .verifyPayment(sessionId)
        .then(() => {
          setTimeout(() => {
            navigate("/dashboard");
          }, 3000);
        })
        .catch(console.error);
    }
  }, [location, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      <Typography variant="h4" color="success.main">
        {t("payment.cancelled")}
      </Typography>

      <CircularProgress />
      <Typography variant="body2">
        {t("payment.redirectingToDashboard")}
      </Typography>
    </Box>
  );
};

export default PaymentCancel;
